import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faCircle } from '@fortawesome/pro-solid-svg-icons';

import { getRequiredFields, getColumnMappings } from '../store/selectors';
import FilesList from '../files-list';

export function MappingFilesList({
  columnMappings,
  requiredFields
}) {

  const countColumnFiles = () => {
    const validationState = [];
    requiredFields.forEach((field) => {
      if (columnFieldExist(field)) {
        validationState.push(field);
      }
    });
    return validationState;
  };

  const validateTotalColumnFiles = () => {
    return requiredFields.length == countColumnFiles().length ? 'panel-success' : 'panel-warning';
  };

  const columnFieldExist = (field) => {
    const column = columnMappings.find(({ columnMapping }) => {
      return field.requiredField === columnMapping.fieldName;
    });
    return column ? true : false;
  };

  const renderRequiredField = (field) => {
    return (
      <p className="field" key={field.requiredField}>
        <span>
          <FontAwesomeIcon icon={columnFieldExist(field) ? faCheckCircle : faCircle} />
        </span>
        {field.humanizedField}
      </p>
    );
  };

  return (
    <React.Fragment>
      <FilesList />
      <div className="mt-5 mb-4">
        <h3 className="semi-bold mb-4">Required Fields</h3>
        <p className="mt-4">
          The fields required to map your data and used to find and merge any duplicates in your data.
        </p>
      </div>
      <div className={classNames('panel required-fields mt-3', validateTotalColumnFiles())}>
        <div className="panel-heading">
          {countColumnFiles().length} of {requiredFields.length} required fields mapped
        </div>
        <div className="panel-body">
          {requiredFields.map(renderRequiredField)}
        </div>
      </div>
    </React.Fragment>
  );
}

MappingFilesList.propTypes = {
  columnMappings: PropTypes.array.isRequired,
  requiredFields: PropTypes.array.isRequired
};

const mapStateToProps = state => ({
  requiredFields: getRequiredFields(state),
  columnMappings: getColumnMappings(state)
});

export default connect(mapStateToProps, null)(MappingFilesList);
